import React, { useEffect, useRef } from 'react';
import AWS from 'aws-sdk';
import { Auth } from 'aws-amplify';
import { AudioPreviewerType } from '../../types/AppTypes';
import { useState } from 'react';
import { Alert, Button, Spinner } from 'react-bootstrap';

const region = process.env.REACT_APP_REGION?.toLowerCase();
const pollyRegion = process.env.REACT_APP_POLLY_REGION?.toLowerCase();
const identityPoolId = process.env.REACT_APP_IDENTITY_POOL_ID || '';
const userPoolId = process.env.REACT_APP_USER_POOL_ID;

const getCognitoIdentityCredentials = async () => {
  const idToken = (await Auth.currentSession()).getIdToken().getJwtToken();

  const loginMap = {
    ['cognito-idp.' + region + '.amazonaws.com/' + userPoolId]: idToken,
  };

  AWS.config.region = region;
  AWS.config.credentials = new AWS.CognitoIdentityCredentials({
    IdentityPoolId: identityPoolId,
    Logins: loginMap,
  });
};

const AudioPreviewer = (props: AudioPreviewerType): JSX.Element => {
  const [text] = useState(props.text);
  const [added, setAdded] = useState(false);
  const [isGenerateSpeechBtnVisible, setIsGenerateSpeechBtnVisible] = useState(false)
  const [generateSpeechBtnText, setGenerateSpeechBtnText] = useState("Generate & Play")
  const [generateSpeechBtnLoading, setGenerateSpeechBtnLoading] = useState(false)
  const [generateSpeechEligible, setGenerateSpeechEligible] = useState(true)
  const [isAutoplay, setIsAutoplay] = useState(props.autoplay)

  const audioRef = useRef<HTMLMediaElement>(null)

  let newText = props.text || '';
  newText = newText.trim();

  const loadTextToSpeech = () => {    
    if ((!added || text !== newText) && newText && newText.length <= 3000 && newText.length > 0) {
      setGenerateSpeechBtnText("Generating...")
      setGenerateSpeechBtnLoading(true)
      getCognitoIdentityCredentials().then(() => {
      setAdded(true);
  
        const polly = new AWS.Polly({
          apiVersion: '2016-06-10',
          region: pollyRegion,
          credentials: AWS.config.credentials,
        });
  
        const { provider, voiceId, engine, sampleRate } = props.document?.speechParams!;
  
        const _voiceId = (provider === 'Azure') ? 'Matthew' : voiceId;
        const _engine = (provider === 'Azure') ? 'neural' : engine;
  
        const params = {
          Engine: _engine,
          OutputFormat: 'mp3',
          SampleRate: sampleRate.toString(),
          TextType: 'text',
          VoiceId: _voiceId,
          Text: props.text
        };
  
        const presignerOptions = {
          params,
          service: polly,
        };
  
        const signer = new AWS.Polly.Presigner(presignerOptions);
        signer.getSynthesizeSpeechUrl(params, function (error, url) {
          if (error) {
            console.log(error);
            setGenerateSpeechBtnText("Generate mp3 & Play")
            setIsGenerateSpeechBtnVisible(false)
            setGenerateSpeechBtnLoading(false)
            setIsAutoplay(false)
          } else {
            (document.getElementById(props.id) as HTMLElement).innerHTML = `<source type="audio/mp3" src="${url}" />`;
            (document.getElementById(props.id) as HTMLAudioElement).load();
            setIsGenerateSpeechBtnVisible(false)
            setGenerateSpeechBtnText("Generate mp3 & Play")
            setGenerateSpeechBtnLoading(false)
            setIsAutoplay(true)
          }
        });
        return {
          text: props.text,
        };
      });
    }
  }

  const checkSelectedTextEligibleForConvertion = () => {
    if(newText.length <= 3000) {
      setGenerateSpeechEligible(true)
    } else {
      setGenerateSpeechEligible(false)
    }
  }

  const handleGenerateSpeechBtnVisibility = () => {
    if(props.text) {
      setIsGenerateSpeechBtnVisible(true)
    } else {
      setIsGenerateSpeechBtnVisible(false)
    }
  }

  const handleRateChange = () => {
    if(isAutoplay) return
    if(audioRef.current != null && audioRef.current != undefined) {
      const rate = audioRef.current.playbackRate
      localStorage.setItem('playbackRate', rate.toString())
    }
  }

  const handleOnLoad = () => {
    if(audioRef.current != null && audioRef.current != undefined) {
      if(localStorage.getItem("playbackRate") !== null && localStorage.getItem("playbackRate") !== undefined) {
        const valuePlayBack = parseFloat(localStorage.getItem("playbackRate")!);
        audioRef.current.playbackRate = valuePlayBack;
      }
    }
  }

  useEffect(() => {
    checkSelectedTextEligibleForConvertion()
    handleGenerateSpeechBtnVisibility()
  }, [props.text])

  useEffect(() => {
    if(audioRef.current != null && audioRef.current != undefined) {
      if(localStorage.getItem("playbackRate")) {
        audioRef.current.playbackRate = parseFloat(localStorage.getItem("playbackRate")!)
      }
    }
  },[audioRef.current])

  return (
    <div className="audio-speech-container" style={{position: "relative"}}>
      {isGenerateSpeechBtnVisible ? (
        <Button onClick={loadTextToSpeech} disabled={generateSpeechBtnLoading || !generateSpeechEligible} style={{ marginRight: '8px', width:'180px' }}>
          {generateSpeechBtnLoading ? (
            <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" style={{ marginRight: '4px' }} />
          ) : null}

          {generateSpeechBtnText}
        </Button>
      ) : null}
      <audio ref={audioRef} id={props.id} controls autoPlay={isAutoplay} onRateChange={handleRateChange} onPlay={handleOnLoad}></audio> 
    </div>
  );
};

export default AudioPreviewer;
